function artReloadedGallery() {

	if ( $( '.ar_gallery' ).length > 0 ) {

		var galleryImages = $( '.ar_gallery' ).find( 'img' ),
			imageExtensions = ["_pico.", "_icon.", "_thumb.", "_small.", "_compact.", "_medium.", "_large.", "_grande.", "_1024x1024.", "_2048x2048." ];

		galleryImages.each( function () {
			var imgSRC = $( this ).attr( 'src' );
			for ( var i = 0; i < imageExtensions.length; i++ ) {
				var newSRC = imgSRC.replace( imageExtensions[i], '.' ); 
				if ( newSRC.length < imgSRC.length ) { 
					break; 
				};
			}; // end for
			$( this ).wrap( '<a href="' + newSRC + '" rel="prettyPhoto[pp_gal]"></a>');
		});
	}; // endif

	return true;

}; // end function

$( document ).ready( function () {

	artReloadedGallery();
	$( "a[rel^='prettyPhoto']" ).prettyPhoto({
            social_tools: false,
            theme: 'pp_default'
        });
	    
});
